<div class="widget-selector" [class.disabled]="isDisabled">
  <div
    class="dropdown-trigger"
    #trigger
    role="button"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-disabled]="isDisabled"
    [attr.tabindex]="isDisabled ? -1 : 0"
    (click)="toggleOpen()"
    (keydown)="onTriggerKeydown($event)">
    @if (icon) {
      <mat-icon class="dropdown-trigger-icon" aria-hidden="true">{{ icon }}</mat-icon>
    }
    @if (singleSelectedLabel()) {
      <span class="dropdown-trigger-value">{{ singleSelectedLabel() }}</span>
    } @else if (multiSelectedCount() > 1) {
      <span class="dropdown-trigger-value">
        {{ "widget-selector.n-selected" | translate: { count: multiSelectedCount() } }}
      </span>
    } @else {
      <span class="dropdown-trigger-label">{{ placeholder }}</span>
    }
    <mat-icon class="dropdown-trigger-arrow" aria-hidden="true" [class.open]="isOpen()">keyboard_arrow_down</mat-icon>
  </div>

  @if (isOpen()) {
    <div class="dropdown-backdrop" (click)="close()"></div>
    <div class="dropdown-panel" [style.top.px]="panelTop" [style.left.px]="panelLeft" [style.width.px]="panelWidth">
      <div class="dropdown-search">
        <mat-icon class="dropdown-search-icon" aria-hidden="true">search</mat-icon>
        <input
          #searchInput
          type="text"
          class="dropdown-search-input"
          [attr.aria-label]="'widget-selector.search-placeholder' | translate"
          [value]="searchQuery()"
          (input)="onSearchInput($event)"
          (keydown.arrowdown)="onSearchArrowDown($event)"
          [placeholder]="'widget-selector.search-placeholder' | translate"
          [title]="'widget-selector.search-placeholder' | translate"
          (click)="$event.stopPropagation()" />
      </div>

      <div class="dropdown-sort-bar">
        <button type="button" class="dropdown-sort-btn" [class.active]="sortField() === 'lastUpdated'" (click)="toggleSort('lastUpdated')">
          {{ "widget-selector.sort-last-updated" | translate }}
          <mat-icon class="dropdown-sort-icon" aria-hidden="true">
            {{ sortField() === "lastUpdated" ? (sortAsc() ? "arrow_upward" : "arrow_downward") : "unfold_more" }}
          </mat-icon>
        </button>
        @if (hasCounts()) {
          <button type="button" class="dropdown-sort-btn" [class.active]="sortField() === 'count'" (click)="toggleSort('count')">
            {{ countLabel || ("widget-selector.sort-count" | translate) }}
            <mat-icon class="dropdown-sort-icon" aria-hidden="true">
              {{ sortField() === "count" ? (sortAsc() ? "arrow_upward" : "arrow_downward") : "unfold_more" }}
            </mat-icon>
          </button>
        }
        <button
          type="button"
          role="switch"
          class="dropdown-live-toggle"
          [class.checked]="onlyLive()"
          [attr.aria-checked]="onlyLive()"
          (click)="onlyLive.set(!onlyLive()); $event.stopPropagation()">
          <span class="dropdown-live-toggle-track" aria-hidden="true"><span class="dropdown-live-toggle-thumb"></span></span>
          <span class="dropdown-live-toggle-label">{{ "widget-selector.published-only" | translate }}</span>
        </button>
      </div>

      <div
        class="dropdown-list"
        role="listbox"
        [attr.aria-multiselectable]="multiple"
        [attr.aria-label]="placeholder || ('widget-selector.list-label' | translate)">
        @for (item of filteredItems(); track item.id) {
          <div
            #optionEl
            class="dropdown-item"
            role="option"
            [attr.aria-selected]="item.isSelected"
            [tabindex]="$index === activeIndex() ? 0 : -1"
            [class.selected]="item.isSelected"
            [class.has-thumbnail]="showThumbnail"
            (click)="selectItem(item)"
            (keydown)="onOptionKeydown($event, item, $index)">
            @if (showThumbnail) {
              @if (item.thumbnailUrl && !failedThumbnails().has(item.thumbnailUrl)) {
                <img class="dropdown-item-thumbnail" [src]="item.thumbnailUrl" alt="" loading="lazy" (error)="onThumbnailError(item.thumbnailUrl)" />
              } @else {
                <span class="dropdown-item-thumbnail dropdown-item-thumbnail--placeholder" aria-hidden="true">
                  <mat-icon>image</mat-icon>
                </span>
              }
            }
            <div class="dropdown-item-body">
              <span class="dropdown-item-name">{{ item.displayLabel }}</span>
              <div class="dropdown-item-subrow">
                @if (item.statusLabelKey) {
                  <span class="status-badge status-badge--{{ item.statusTone }}">
                    <span class="status-badge-dot" aria-hidden="true"></span>
                    <span class="status-badge-label">{{ item.statusLabelKey | translate }}</span>
                  </span>
                }
                @if (item.subLabel) {
                  <span class="dropdown-item-variant">{{ item.subLabel }}</span>
                }
                @if (hasCounts()) {
                  <span class="dropdown-item-variant">{{ item.openCount | number }} {{ countLabel || ("widget-selector.sort-count" | translate) }}</span>
                }
              </div>
            </div>
            @if (multiple) {
              <mat-icon class="dropdown-item-check" aria-hidden="true">
                {{ item.isSelected ? "check_box" : "check_box_outline_blank" }}
              </mat-icon>
            }
          </div>
        }
        @if (filteredItems().length === 0) {
          <div class="dropdown-empty">
            {{ "widget-selector.no-matching" | translate }}
          </div>
        }
      </div>

      @if (multiple) {
        <div class="dropdown-footer">
          <span class="dropdown-footer-count" aria-live="polite">
            {{ "widget-selector.selected-count" | translate: { count: multiSelectedCount() } }}
          </span>
          <button type="button" class="dropdown-footer-clear" [disabled]="multiSelectedCount() === 0" (click)="clearSelection(); $event.stopPropagation()">
            {{ "widget-selector.clear" | translate }}
          </button>
        </div>
      }
    </div>
  }
</div>
